/**
 * Sprint v1.6 Stufe 4C (Mi 02.09.2026) — Kommunikationspaket.
 *
 * Zeigt die 6 Ebenen, aus denen ein Türöffner besteht:
 * Inhalt + Ton + Sprache + Struktur + Ansprache + Rahmen.
 *
 * Sprachprinzip v8: Alltagssprache, keine Anglizismen, keine Coach-Sprache.
 * Copy morgen früh (03.09.) durch Andreas redaktionell reviewt.
 */
import React from "react";
import { Package, MessageSquare, Volume2, BookOpen, Layers, User, Frame } from "lucide-react";

// 6 Ebenen des Kommunikationspakets.
const EBENEN = [
  {
    id: "inhalt",
    icon: MessageSquare,
    label: "Inhalt",
    subline: "Was du sagst.",
  },
  {
    id: "ton",
    icon: Volume2,
    label: "Ton",
    subline: "Wie es klingt.",
  },
  {
    id: "sprache",
    icon: BookOpen,
    label: "Sprache",
    subline: "Welche Worte.",
  },
  {
    id: "struktur",
    icon: Layers,
    label: "Struktur",
    subline: "In welcher Reihenfolge.",
  },
  {
    id: "ansprache",
    icon: User,
    label: "Ansprache",
    subline: "Wen du meinst.",
  },
  {
    id: "rahmen",
    icon: Frame,
    label: "Rahmen",
    subline: "Wo & wann.",
  },
];

export default function Kommunikationspaket() {
  return (
    <section
      className="rounded-2xl bg-white border border-slate-200 p-6"
      data-testid="kommunikationspaket-section"
    >
      <div className="flex items-start gap-3 mb-5">
        <div className="w-10 h-10 flex-shrink-0 rounded-full bg-[var(--fts-primary-bright)]/10 flex items-center justify-center">
          <Package className="w-5 h-5 text-[var(--fts-primary-bright)]" />
        </div>
        <div>
          <p className="text-xs font-bold uppercase tracking-widest text-[var(--fts-primary-bright)]">
            Kommunikationspaket
          </p>
          <h3
            className="mt-1 text-lg sm:text-xl font-extrabold text-slate-900"
            data-testid="kommunikationspaket-titel"
          >
            Sechs Ebenen, die zusammen wirken.
          </h3>
          <p className="mt-1 text-sm text-slate-600">
            Ein Türöffner ist nie nur ein Satz. Er ist alle sechs Ebenen im Einklang.
          </p>
        </div>
      </div>

      <div
        className="grid grid-cols-2 sm:grid-cols-3 gap-3"
        data-testid="kommunikationspaket-grid"
      >
        {EBENEN.map((e) => {
          const Icon = e.icon;
          return (
            <div
              key={e.id}
              className="rounded-xl border border-slate-200 bg-slate-50 p-3 flex items-start gap-2.5"
              data-testid={`kommunikationspaket-ebene-${e.id}`}
            >
              <Icon className="w-4 h-4 text-[var(--fts-primary-bright)] flex-shrink-0 mt-0.5" />
              <div className="min-w-0">
                <p className="text-sm font-bold text-slate-900 leading-tight">
                  {e.label}
                </p>
                <p className="text-xs text-slate-600 leading-snug mt-0.5">
                  {e.subline}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
